import PropTypes from 'prop-types';
import React, {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';


export default function ScrollToTop({children}) {
  const location = useLocation();
  const prevPathnameRef = useRef(location.pathname);

  useEffect(() => {
    if(prevPathnameRef.current !== location.pathname){
      window.scrollTo(0, 0);
      prevPathnameRef.current = location.pathname;
    }
  }, [location.pathname]);

  return children;
}

ScrollToTop.propTypes = {
  children: PropTypes.node,
};
